<template>
<div class="pgInner affairEdit">

    <div class="headBar">栏目管理</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
        <el-scrollbar ref="scroller" style="height:100%;">
            <div class="tabNavs" ref="tabNavs">
                <div v-for="(item,index) in navs" :key="index" @click="tabChange($event,index)" :class="['tabItem',{'act':navAct===index}]">
                    {{item}}
                </div>
                <div class="moveLine" :style="lineStr"></div>
            </div>
            <div class="tabContent">
                <div class="subpage addrule_edit">

                    <el-form v-show="navAct===0" :model="ruleForm" :rules="firstRules" ref="firstTab" label-width="120px">
                        <el-form-item label="所属栏目" class="selectGp">
                            <el-cascader size="medium" ref="cascaderColumn" :options="columnTree" :show-all-levels="true" :props="{ value: 'id', label: 'name', children: 'dtos' ,checkStrictly: true}" :value="ids" @change="handleColumnChange" clearable placeholder="请选择"></el-cascader>
                        </el-form-item>
                        <el-form-item label="栏目名称" style="width: 100%" prop="name">
                            <el-input size="medium" v-model="ruleForm.name" placeholder="请输入栏目全称"></el-input>
                        </el-form-item>
                        <!-- 栏目图 -->
                        <el-form-item label="栏目图">
                            <imgs-upload v-model="ruleForm.thumbnail" @change="fileChange" tips="（115*70推荐）" limit="1" />
                        </el-form-item>
                        <!-- 栏目图end-->
                        <el-form-item label="栏目模板" prop="modelLink">
                            <el-input size="medium" v-model="ruleForm.modelLink"></el-input>
                        </el-form-item>
                        <el-form-item label="内容页模板" prop="contentLink" style="width: 500">
                            <el-input size="medium" v-model="ruleForm.contentLink"></el-input>
                        </el-form-item>
                        <el-form-item label="目标窗口">
                            <el-radio-group v-model="ruleForm.window">
                                <el-radio :label="1">本窗口</el-radio>
                                <el-radio :label="2">新窗口</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="自定义链接" style="width: 500">
                            <el-input size="medium" v-model="ruleForm.customLink"></el-input>
                            <i class="tip">当栏目需要指向其他页面，可通过自定义链接实现</i>
                        </el-form-item>
                        <!-- 排序 -->
                        <el-form-item label="排序">
                            <el-input-number size="medium" v-model="ruleForm.weight" controls-position="right" @change="handleChange" :min="0"></el-input-number>
                        </el-form-item>
                        <!-- 排序end-->
                        <!-- <el-form-item label="是否显示">
                            <el-switch v-model="ruleForm.isDisplay" :active-value="1" :inactive-value="2"></el-switch>
                        </el-form-item> -->

                    </el-form>
                    <!-- 基本设置end -->

                    <!-- 其他设置 -->
                    <el-form v-show="navAct===1" :model="ruleForm" :rules="secondRules" ref="secondTab" label-width="120px">
                        <el-form-item label="SEO标题" prop="seoTitle">
                            <el-input size="medium" v-model="ruleForm.seoTitle"></el-input>
                        </el-form-item>
                        <el-form-item label="SEO关键字" prop="seoKeyword">
                            <el-input size="medium" v-model="ruleForm.seoKeyword"></el-input>
                        </el-form-item>
                        <el-form-item label="SEO描述内容" prop="seoDesc">
                            <el-input size="medium" style="width: 48%" type="textarea" v-model="ruleForm.seoDesc"></el-input>
                        </el-form-item>
                        <el-form-item label="内容" prop="content">
                            <el-input size="medium" style="width: 48%" type="textarea" v-model="ruleForm.content"></el-input>
                        </el-form-item>

                    </el-form>
                    <!-- 其他设置end -->

                </div>
            </div>
        </el-scrollbar>
    </div>

    <div class="pagefoot">

        <div v-if="pgState" class="loading">
            <span v-if="pgState == 1">初始化中...</span>
            <span v-if="pgState == 2">数据保存中...</span>
            <i class="el-icon-loading"></i>
        </div>
        <div v-else>
            <el-button @click="goSave()" type="primary" size="small">保存</el-button>
            <el-button @click="goBack()" size="small">返回</el-button>
        </div>

    </div>

</div>
</template>

<script>
import {
    addColumnDTO,
    getColumnTree,
    getColumnDTOById
} from '@/api/jingshi';

export default {
    computed: {
        lineStr: function () {
            var str = 'width:60px;';
            str = str + "left:" + this.navX + "px;";
            return str;
        },
        pgState: function () {
            var state = 0;
            if (this.id && this.readyKey !== 3) {
                state = 1;
            }

            if (this.uploadIng) {
                state = 2;
            }

            return state;
        }
    },
    data() {
        return {
            navs: ['基本设置', '其他设置'],
            navAct: 0,
            navX: 15,
            pageH: '',
            readyKey: 0,

            columnTree: [],
            ids: [],

            ruleForm: {
                id: '',
                parentId: '', // 父栏目id
                seoKeyword: '', // SEO关键字
                thumbnail: '', // 栏目图
                modelLink: '', // 信息页模板链接
                weight: 0, // 权重排序
                seoTitle: '', // SEO标题
                seoDesc: '', // SEO描述内容
                isDisplay: 2, // 1 显示 2 隐藏
                content: '', // 内容
                name: '', // 栏目名称
                contentLink: '', // 内容页模板
                window: 0, // 目标窗口模板 1本窗口 2新窗口
                customLink: '', // 自定义链接
            },
            // 基本设置tip
            firstRules: {
                name: [{
                        required: true,
                        message: '请输入栏目名称',
                        trigger: 'blur'
                    },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                // modelLink: [{
                //         required: true,
                //         message: '请输入栏目模板',
                //         trigger: 'blur'
                //     },
                //     // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                // ],
                // contentLink: [{
                //         required: true,
                //         message: '请输入内容页模板',
                //         trigger: 'blur'
                //     },
                //     // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                // ],
            },
            // 其他设置tip
            secondRules: {
                // seoTitle: [{
                //         required: true,
                //         message: '请输入SEO标题',
                //         trigger: 'blur'
                //     },
                //     // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                // ],
                // seoKeyword: [{
                //         required: true,
                //         message: '请输入SEO关键字',
                //         trigger: 'blur'
                //     },
                //     // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                // ],
                // seoDesc: [{
                //         required: true,
                //         message: '请输入SEO描述内容',
                //         trigger: 'blur'
                //     },
                //     // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                // ],
                // content: [{
                //         required: true,
                //         message: '请输入内容',
                //         trigger: 'blur'
                //     },
                //     // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                // ],
            },
        };
    },
    methods: {
        // 标签页
        handleClick(tab, event) {
            // console.log(tab, event);
        },
        // 栏目变动
        handleColumnChange(e) {
            console.log(e)
            var checkLabels = this.$refs['cascaderColumn'].getCheckedNodes();
            console.log(checkLabels[0].label, checkLabels[0].value);
            this.ruleForm.parentId = checkLabels[0].value;
        },

        // // 发Ajax
        save() {
            this.ruleForm.class_type = 'TCmsColumn';
            addColumnDTO({
                dto: this.ruleForm
            }).then(res => {
                console.log(res);
                this.$message.success('操作成功！');
            }).catch(err => {
                console.log(err)
                this.$message.error('保存失败!')
            })
        },
        goSave() {
            if (this.navAct == 0) {
                this.firstSave();
            }
            if (this.navAct == 1) {
                this.secondSave();
            }
        },
        // 保存
        firstSave() {
            var vues = this;
            vues.$refs.firstTab.validate((valid) => {
                if (valid) {
                    this.save();
                    vues.goBack();
                }
            });
        },
        secondSave() {
            var vues = this;
            vues.$refs.secondTab.validate((valid) => {
                if (valid) {
                    this.save();
                    vues.goBack();
                }
            });

        },
        fileChange: function (e) {
            console.log(e);
            // this.params.image = JSON.stringify(e);
        },
        // 返回
        goBack() {
            this.$router.go(-1);
        },
        handleTree(data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i]['dtos'].length == 0) {
                    delete data[i].dtos;
                } else {
                    this.handleTree(data[i]['dtos']);
                }
            }
            return data;
        },
        // 获取栏目数据
        getColumnDTO() {
            var vues = this;
            getColumnDTOById({
                id: this.ruleForm.id
            }).then(res => {
                vues.ruleForm = res.dto;
                // var arr = res.dto.pids.split(",").reverse();
                var arr = res.dto.pids.split(",");
                vues.ids = arr.slice(0, arr.length - 1);

                // if (res.dto.isDisplay == 1) {
                //     vues.isDisplay = true;
                // } else {
                //     vues.isDisplay = false;
                // }

            })
        },
        getColumnTree() {
            var vues = this;

            getColumnTree().then(res => {
                vues.columnTree = vues.handleTree(res.cmsColumnLists);
                console.log(res.cmsColumnLists);
            })
        },
        tabChange: function (e, inx) {
            // var tabNavs = this.$refs.tabNavs;
            this.navAct = inx;
            this.navX = e.target.offsetLeft;
        },

        pageFix: function () {
            this.pageH = document.documentElement.clientHeight - 205;
        },
    },
    created: function () {
        this.ruleForm.level = this.$route.query.level;
        if (this.$route.query.id) {
            this.ruleForm.id = this.$route.query.id;
            this.getColumnDTO();
        }
        if (this.$route.query.parentId) {
            this.ruleForm.parentId = this.$route.query.parentId;
        }
        this.getColumnTree();
        // 
    }
}
</script>

<style lang="scss" scoped>
.pgInner {
    background: #f5f5f5;
}

.headBar {
    height: 55px;
    line-height: 55px;
    font-size: 16px;
    padding-left: 20px;
    background: white;
}

.tabNavs {
    height: 50px;
    padding-left: 15px;
    background: white;
    position: relative;

    .tabItem {
        float: left;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        margin-right: 45px;
        cursor: pointer;
    }

    .tabItem.act {
        color: rgb(86, 119, 252);
    }

    .moveLine {
        height: 2px;
        background: rgb(86, 119, 252);
        position: absolute;
        bottom: 0px;

        transition-property: all;
        transition-duration: 0.2s;
    }
}

.tabContent {
    padding: 20px;
    background: white;
}

.pagefoot {
    height: 60px;
    line-height: 60px;
    background: white;
    padding-left: 20px;
    position: relative;
    z-index: 2;

    .btn {
        height: 32px;
        padding: 0 12px;
        margin-right: 12px;
        display: inline-block;
        font-size: 14px;
        cursor: pointer;
    }

    .type1 {
        line-height: 32px;
        background: rgb(86, 119, 252);
        color: white;
    }

    .type2 {
        box-sizing: border-box;
        border: 1px solid #aeaeae;
        line-height: 30px;
    }

    .loading {
        font-size: 14px;
        padding-left: 24px;
        color: #aeaeae;

        i {
            font-size: 18px;
            vertical-align: middle;
        }
    }
}
</style>

<style lang="css">
.affairEdit .pgbody {
    margin: 20px;
    background: white;
}

@media only screen and (max-width: 1366px) {
    .affairEdit .pgbody {
        margin: 10px 0;
    }
}

.subpage.addrule_edit .el-input__inner {
    border-radius: 0px !important;
}

.subpage.addrule_edit .el-input-number {
    width: 240px !important;
}

el--number .subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?0ad10d8b